import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const dashboardSlice = createApi({
  reducerPath: "dashboardSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: commonBaseUrl,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
      const state = getState();
      const token = state.auth?.token;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getTabs: builder.query({
      query: () => ({
        url: `/dashboard/fetchTabs`,
        method: "GET",
      }),
      transformResponse: (response) => response,
    }),
  }),
});

export const { useGetTabsQuery } = dashboardSlice;
